module.exports = __webpack_public_path__ + "static/media/tabs-image-01.7095dc71.jpg";